import Homebutton from "../Homebutton";

function Sync() {
  return (
    <div className='container'>
      <div className='container-box'>
        <h2 className='text-center'>WEL of GEEN SYNC bepalen met Monteurs-app</h2>

        <section className="card-box">
          <h2>Geen Sync</h2>

          <section>
            <h3>Stappenplan geen sync</h3>
            <p>
              Als je geen sync op je lijn krijgt kunnen dat meerder oorzaken
              hebben, om uit te vinden wat de oorzaak is van het probleem voeren
              we een selt meting uit.
            </p>
          </section>

          <section>
            <h3>Uitkomsten van een selt meting</h3>
            <ul>
              <li>
                <strong>Short</strong> = sluiting
              </li>
              <li>
                <strong>Open lijn</strong>
              </li>
              <li>
                <strong>No CPE Detected</strong> = Spanningsloos modem
              </li>
            </ul>
          </section>

          <section>
            <h3>Stappen bij sluiting of open lijn</h3>
            <p>
              Bij een sluiting of een open lijn kijk je naar de lengte van de
              SELT meting.
              <br />
              Vervolgens Sip24 checken. Hiermee bepaal je of je bij de klant of
              KVD/HVD moet zijn.
            </p>
            <section>
              <h4>Bij de klant</h4>
              <ul>
                <li>
                  Bij een 1x2 ISRA : Is de afwijking tussen de SIP24 en jouw
                  lengte minder dan 20% dan ten alle tijden een pieper ophangen.
                </li>
              </ul>
            </section>

            <section>
              <h4>Bij KVD en/of HVD</h4>
              <ul>
                <li>Kruisdraden checken</li>
                <li>
                  Meet het koper op een <strong>open</strong> lijn (vermeld de
                  meetwaardes altijd in de Voortgang)
                </li>
                <li>
                  Bij een foute meting in een voeding bel je MI/monteursingang
                  (Infra)die je 5 vrije aders geeft die je moet meten voordat je
                  een voeding naar OG kunt aansturen
                </li>
                <li>
                  Ten alle tijden meet je Sync op het laatste manipulatiepunt
                </li>
              </ul>
            </section>
          </section>

          <section>
            <h3>Stappen bij Spanningsloos modem</h3>
            <p>Je gaat naar de klant voor verder onderzoek en oplossing.</p>
          </section>

          <section>
            <h3>Vermoed je dat de poort defect is</h3>
            <p>
              Maak sluiting op de HVD bij de poort. Vervolgens de SELT meting en
              meet je GEEN sluiting bel dan MI/monteursingang (Infra)
            </p>
          </section>
        </section>

        <section className="card-box">
          <h2>Wel Sync</h2>

          <section>
            <h3>Stappenplan bij wel Sync</h3>
            <ul>
              <li>Ga eerst naar de klant</li>
              <li>Open de ISRA en meet het koper</li>
              <li>
                Vervang altijd het ISRA2 doosje en lasdop, eventueel bridgetap
                verwijderen.
              </li>
            </ul>
          </section>

          <section>
            <h3>Koper meet goed</h3>
            <ul>
              <li>
                Fysiek binnengeleiding checken bij KPN klanten tussen ISRA en
                modem (check of er geen lasjes of doosjes tussen zitten), bij
                twijfel vervangen door CAT5
              </li>
              <li>Modem vervangen (alleen bij KPN klanten)</li>
            </ul>
          </section>

          <section>
            <h3>zachte fouten</h3>
            <p>
              Zijn er nog zachte fouten (te lage snelheid, glitches/freezes),
              door bijv externe stoorbron of overspraak?
            </p>

            <ul>
              <li>
                Dit is <strong>GEEN</strong> reden om ondergronds aan te sturen.
              </li>
              <li>
                Bij snelheid te laag check in Monteurapp de snelheid van
                meerdere buren, liefst de hele buurt.
              </li>
              <li>Overleg met een ASS+ monteur of een specialist.</li>
            </ul>
          </section>

          <section>
            <h3>Koper meet niet goed</h3>
            <ul>
              <li>
                Bepaal waar het niet goed is: tussen ISRA-KVD/HVD of KVD-HVD
              </li>
              <li>
                Check via de Monteurapp (HIO) of er mogelijkheden zijn tot
                omsteken
              </li>
              <li>Bel met MI/monteursingang (Infra): voor omsteken.</li>
              <li>
                Igv omsteken niet mogelijk, dan wordt Ondergronds aangestuurd:
                Alle meetwaardes in voortgang zetten, i.o.m. MI de opdracht
                “Uncompleted”
              </li>
              <li>
                melden met afmeldcode voor aansturen ondergronds. In overleg met
                de klant wordt in de call met MI de afspraak voor Ondergronds
                gemaakt.
              </li>
            </ul>
          </section>
        </section>
        <Homebutton />
      </div>
    </div>
  );
}

export default Sync;
